module.exports = __webpack_public_path__ + "img/b63bc5e.jpg";